export interface CepResult {
	street: string;
	district: string;
	city: string;
	uf: string;
}

export async function lookupCep(cep: string): Promise<CepResult | null> {
	const d = cep.replaceAll(/\D/gu, "");

	if (d.length !== 8) {
		return null;
	}

	const res = await fetch(`https://viacep.com.br/ws/${d}/json/`)
		.then((r) => r.json())
		.catch(() => null);

	if (!res || res.erro) {
		return null;
	}

	return { street: res.logradouro, district: res.bairro, city: res.localidade, uf: res.uf };
}
